import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";

// Suppress postMessage DataCloneError globally (browser internals)
const origPostMessage = window.postMessage.bind(window);
window.postMessage = function(message, ...args) {
  try {
    return origPostMessage(message, ...args);
  } catch (e) {
    if (e?.name === "DataCloneError" || e?.message?.includes("could not be cloned")) {
      return;
    }
    throw e;
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
